<!-- APP HEADER -->
<header class="ocr-app-header">
  <span class="ocr-app-title">OpenPYQ &mdash; OCR Preview</span>
  <div class="ocr-header-actions">
    <button class="header-action-btn" title="Settings">&#9881;</button>
    <button class="header-action-btn logout-btn" title="Logout">Logout</button>
  </div>
</header>

<div class="ocr-layout" [class.nav-collapsed]="navCollapsed" [class.dragging]="isNavDragging || isMainDragging">

  <!-- LEFT PANE: Navigation -->
  <aside class="nav-pane" [style.flex]="navFlex">
    <div class="nav-header">
      <span class="nav-title" *ngIf="!navCollapsed">Subjects</span>
      <button class="nav-collapse-btn" (click)="toggleNavCollapse()" [title]="navCollapsed ? 'Expand navigation' : 'Collapse navigation'">
        {{ navCollapsed ? '▶' : '◀' }}
      </button>
    </div>
    <div class="nav-tree" *ngIf="!navCollapsed">
      <ng-container *ngFor="let subject of nav">
        <div class="nav-subject" (click)="subject.expanded = !subject.expanded">
          <span class="nav-caret">{{ subject.expanded ? '▾' : '▸' }}</span>
          {{ subject.label }}
        </div>
        <ng-container *ngIf="subject.expanded">
          <ng-container *ngFor="let section of subject.sections">
            <div class="nav-section" (click)="section.expanded = !section.expanded">
              <span class="nav-caret">{{ section.expanded ? '▾' : '▸' }}</span>
              {{ section.label }}
            </div>
            <ng-container *ngIf="section.expanded">
              <div
                *ngFor="let leaf of section.children"
                class="nav-leaf"
                [class.selected]="leaf.selected"
                (click)="selectLeaf(subject, section, leaf)">
                {{ leaf.label }}
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </aside>

  <!-- NAV DIVIDER -->
  <div class="vertical-divider nav-divider"
       [class.dragging]="isNavDragging"
       (mousedown)="onNavMouseDown($event)"
       (dblclick)="resetNavSize()"
       title="Drag to resize · Double-click to reset">
  </div>

  <!-- CENTER PANE: Question Cards -->
  <main class="questions-pane">
    <div class="questions-toolbar">
      <span class="breadcrumb">{{ breadcrumbSection }} &rarr; {{ breadcrumbTopic }}</span>
      <div class="toolbar-controls">
        <!-- Display Mode -->
        <div class="ctrl-group">
          <label class="ctrl-label">Display Mode</label>
          <select class="ctrl-select" [(ngModel)]="displayMode" (change)="onDisplayModeChange()">
            <option value="all">Load All Questions</option>
            <option value="expandAll">Expand All</option>
            <option value="collapseAll">Collapse All</option>
          </select>
        </div>
        <!-- Language -->
        <div class="ctrl-group">
          <label class="ctrl-label">Language</label>
          <select class="ctrl-select" [(ngModel)]="language">
            <option value="english">English Only</option>
            <option value="bilingual">Bilingual</option>
          </select>
        </div>
        <!-- Vertical Options -->
        <label class="ctrl-toggle">
          <input type="checkbox" [(ngModel)]="optionsVertical"> Vertical Options
        </label>
        <!-- Side-by-Side (bilingual only) -->
        <label class="ctrl-toggle" *ngIf="language === 'bilingual'">
          <input type="checkbox" [(ngModel)]="sideBySide"> Side-by-Side
        </label>
        <!-- Show Answer -->
        <button class="toggle-btn" (click)="toggleAnswer()">
          {{ showAnswer ? 'Hide Answer' : 'Show Answer' }}
        </button>
      </div>
    </div>

    <div *ngIf="isLoading" class="loading-msg">Loading questions…</div>

    <div *ngIf="!isLoading && questions.length === 0" class="empty-msg">No questions loaded.</div>

    <div class="cards-list" *ngIf="!isLoading && questions.length > 0">
      <div
        *ngFor="let q of questions; let i = index"
        class="q-card"
        [class.active]="selectedQuestion === q"
        [class.collapsed]="q.collapsed"
        (click)="selectQuestion(q)">

        <div class="q-card-header">
          <span class="q-num">Q{{ i + 1 }}</span>
          <span class="q-exam" *ngIf="q.examLabel">{{ q.examLabel }}</span>
          <button class="q-collapse-btn" (click)="toggleCardCollapse(q, $event)" [title]="q.collapsed ? 'Expand' : 'Collapse'">
            {{ q.collapsed ? '&#8964;' : '&#8963;' }}
          </button>
        </div>

        <ng-container *ngIf="!q.collapsed">

          <!-- SIDE-BY-SIDE bilingual layout -->
          <ng-container *ngIf="language === 'bilingual' && sideBySide">
            <div class="bilingual-cols">
              <!-- English column -->
              <div class="bilingual-col">
                <div class="bilingual-col-lang">EN</div>
                <p class="q-text" [innerHTML]="fmt(q.questionText)"></p>
                <div class="options-list" [class.options-vertical]="optionsVertical" *ngIf="q.optionAText">
                  <div class="opt" [class.correct]="isCorrect(q, 'A')">
                    <span class="opt-label">(a)</span><span class="opt-text" [innerHTML]="fmt(q.optionAText)"></span>
                  </div>
                  <div class="opt" [class.correct]="isCorrect(q, 'B')" *ngIf="q.optionBText">
                    <span class="opt-label">(b)</span><span class="opt-text" [innerHTML]="fmt(q.optionBText)"></span>
                  </div>
                  <div class="opt" [class.correct]="isCorrect(q, 'C')" *ngIf="q.optionCText">
                    <span class="opt-label">(c)</span><span class="opt-text" [innerHTML]="fmt(q.optionCText)"></span>
                  </div>
                  <div class="opt" [class.correct]="isCorrect(q, 'D')" *ngIf="q.optionDText">
                    <span class="opt-label">(d)</span><span class="opt-text" [innerHTML]="fmt(q.optionDText)"></span>
                  </div>
                </div>
              </div>
              <!-- Hindi column -->
              <div class="bilingual-col" *ngIf="!q.missingHindi">
                <div class="bilingual-col-lang">HI</div>
                <p class="q-text q-text-hindi" [innerHTML]="fmt(q.hindiQuestionText)"></p>
                <div class="options-list options-hindi" [class.options-vertical]="optionsVertical" *ngIf="q.hindiOptionAText">
                  <div class="opt" [class.correct]="isCorrect(q, 'A')">
                    <span class="opt-label">(a)</span><span class="opt-text" [innerHTML]="fmt(q.hindiOptionAText)"></span>
                  </div>
                  <div class="opt" [class.correct]="isCorrect(q, 'B')" *ngIf="q.hindiOptionBText">
                    <span class="opt-label">(b)</span><span class="opt-text" [innerHTML]="fmt(q.hindiOptionBText)"></span>
                  </div>
                  <div class="opt" [class.correct]="isCorrect(q, 'C')" *ngIf="q.hindiOptionCText">
                    <span class="opt-label">(c)</span><span class="opt-text" [innerHTML]="fmt(q.hindiOptionCText)"></span>
                  </div>
                  <div class="opt" [class.correct]="isCorrect(q, 'D')" *ngIf="q.hindiOptionDText">
                    <span class="opt-label">(d)</span><span class="opt-text" [innerHTML]="fmt(q.hindiOptionDText)"></span>
                  </div>
                </div>
              </div>
              <div class="bilingual-col missing-col" *ngIf="q.missingHindi">
                <span class="missing-badge">Hindi N/A</span>
              </div>
            </div>
          </ng-container>

          <!-- STACKED layout (english-only or bilingual stacked) -->
          <ng-container *ngIf="language !== 'bilingual' || !sideBySide">
            <p class="q-text" [innerHTML]="fmt(q.questionText)"></p>

            <!-- Question figure -->
            <div class="q-figure" *ngIf="q.questionFigureUrl">
              <img [src]="q.questionFigureUrl" [alt]="q.questionFigureCaption || 'Figure'" class="q-fig-img">
              <p *ngIf="q.questionFigureCaption" class="q-fig-caption">{{ q.questionFigureCaption }}</p>
            </div>

            <!-- English options -->
            <div class="options-list" [class.options-vertical]="optionsVertical" *ngIf="q.optionAText">
              <div class="opt" [class.correct]="isCorrect(q, 'A')">
                <span class="opt-label">(a)</span><span class="opt-text" [innerHTML]="fmt(q.optionAText)"></span>
              </div>
              <div class="opt" [class.correct]="isCorrect(q, 'B')" *ngIf="q.optionBText">
                <span class="opt-label">(b)</span><span class="opt-text" [innerHTML]="fmt(q.optionBText)"></span>
              </div>
              <div class="opt" [class.correct]="isCorrect(q, 'C')" *ngIf="q.optionCText">
                <span class="opt-label">(c)</span><span class="opt-text" [innerHTML]="fmt(q.optionCText)"></span>
              </div>
              <div class="opt" [class.correct]="isCorrect(q, 'D')" *ngIf="q.optionDText">
                <span class="opt-label">(d)</span><span class="opt-text" [innerHTML]="fmt(q.optionDText)"></span>
              </div>
            </div>

            <!-- Hindi section (bilingual stacked) -->
            <ng-container *ngIf="language === 'bilingual'">
              <div class="hindi-divider" *ngIf="!q.missingHindi">&#x092D;&#x093E;&#x0930;&#x0924;&#x0940;&#x092F; &#x092D;&#x093E;&#x0937;&#x093E;</div>
              <span class="missing-badge" *ngIf="q.missingHindi">Hindi N/A</span>
              <p class="q-text q-text-hindi" *ngIf="!q.missingHindi && q.hindiQuestionText"
                 [innerHTML]="fmt(q.hindiQuestionText)"></p>
              <div class="options-list options-hindi" [class.options-vertical]="optionsVertical"
                   *ngIf="!q.missingHindi && q.hindiOptionAText">
                <div class="opt" [class.correct]="isCorrect(q, 'A')">
                  <span class="opt-label">(a)</span><span class="opt-text" [innerHTML]="fmt(q.hindiOptionAText)"></span>
                </div>
                <div class="opt" [class.correct]="isCorrect(q, 'B')" *ngIf="q.hindiOptionBText">
                  <span class="opt-label">(b)</span><span class="opt-text" [innerHTML]="fmt(q.hindiOptionBText)"></span>
                </div>
                <div class="opt" [class.correct]="isCorrect(q, 'C')" *ngIf="q.hindiOptionCText">
                  <span class="opt-label">(c)</span><span class="opt-text" [innerHTML]="fmt(q.hindiOptionCText)"></span>
                </div>
                <div class="opt" [class.correct]="isCorrect(q, 'D')" *ngIf="q.hindiOptionDText">
                  <span class="opt-label">(d)</span><span class="opt-text" [innerHTML]="fmt(q.hindiOptionDText)"></span>
                </div>
              </div>
            </ng-container>

          </ng-container>

        </ng-container>

      </div>
    </div>
  </main>

  <!-- MAIN DIVIDER (between questions and details) -->
  <div class="vertical-divider main-divider"
       *ngIf="showDetails"
       [class.dragging]="isMainDragging"
       (mousedown)="onMainMouseDown($event)"
       (dblclick)="resetMainSize()"
       title="Drag to resize · Double-click to reset">
  </div>

  <!-- RIGHT PANE: Details -->
  <aside class="details-pane" [class.open]="showDetails" [style.flex]="showDetails ? detailFlex : '0 0 0px'">
    <ng-container *ngIf="showDetails && selectedQuestion">
      <div class="details-header">
        <div class="details-header-left">
          <span class="details-title">Details</span>
          <label class="det-check"><input type="checkbox" [(ngModel)]="showQuestionAlso"> Show Question</label>
          <label class="det-check"><input type="checkbox" [(ngModel)]="showHindi"> Show Hindi</label>
        </div>
        <button class="close-btn" (click)="closeDetails()">✕</button>
      </div>

      <div class="details-body">
        <!-- Question -->
        <div class="detail-section" *ngIf="showQuestionAlso">
          <div class="detail-label">Question</div>
          <p class="detail-text" [innerHTML]="fmt(selectedQuestion.questionText)"></p>
          <div *ngIf="selectedQuestion.questionFigureUrl" class="detail-figure">
            <img [src]="selectedQuestion.questionFigureUrl"
                 [alt]="selectedQuestion.questionFigureCaption || 'Figure'"
                 class="detail-fig-img">
          </div>
        </div>

        <!-- Options -->
        <div class="detail-section" *ngIf="selectedQuestion.optionAText">
          <div class="detail-label">Options</div>
          <div class="detail-options">
            <div class="detail-opt" [class.correct]="getCorrectLetter(selectedQuestion) === 'A'">
              <b>(a)</b> {{ selectedQuestion.optionAText }}
            </div>
            <div class="detail-opt" [class.correct]="getCorrectLetter(selectedQuestion) === 'B'" *ngIf="selectedQuestion.optionBText">
              <b>(b)</b> {{ selectedQuestion.optionBText }}
            </div>
            <div class="detail-opt" [class.correct]="getCorrectLetter(selectedQuestion) === 'C'" *ngIf="selectedQuestion.optionCText">
              <b>(c)</b> {{ selectedQuestion.optionCText }}
            </div>
            <div class="detail-opt" [class.correct]="getCorrectLetter(selectedQuestion) === 'D'" *ngIf="selectedQuestion.optionDText">
              <b>(d)</b> {{ selectedQuestion.optionDText }}
            </div>
          </div>
        </div>

        <!-- Answer -->
        <div class="detail-section answer-section">
          <div class="detail-label">Answer</div>
          <p class="answer-text">{{ selectedQuestion.answerText }}</p>
        </div>

        <!-- Exam -->
        <div class="detail-section" *ngIf="selectedQuestion.examLabel">
          <div class="detail-label">Exam</div>
          <p class="detail-text">{{ selectedQuestion.examLabel }}</p>
        </div>

        <!-- Hindi content (when showHindi is checked) -->
        <ng-container *ngIf="showHindi">
          <div class="detail-section" *ngIf="selectedQuestion.hindiQuestionText">
            <div class="detail-label">&#x092A;&#x094D;&#x0930;&#x0936;&#x094D;&#x0928; (Hindi)</div>
            <p class="detail-text hindi-text" [innerHTML]="fmt(selectedQuestion.hindiQuestionText)"></p>
          </div>
          <div class="detail-section" *ngIf="selectedQuestion.hindiOptionAText">
            <div class="detail-label">&#x0935;&#x093F;&#x0915;&#x0932;&#x094D;&#x092A; (Hindi)</div>
            <div class="detail-options">
              <div class="detail-opt" [class.correct]="getCorrectLetter(selectedQuestion) === 'A'">
                <b>(a)</b> <span [innerHTML]="fmt(selectedQuestion.hindiOptionAText)"></span>
              </div>
              <div class="detail-opt" [class.correct]="getCorrectLetter(selectedQuestion) === 'B'" *ngIf="selectedQuestion.hindiOptionBText">
                <b>(b)</b> <span [innerHTML]="fmt(selectedQuestion.hindiOptionBText)"></span>
              </div>
              <div class="detail-opt" [class.correct]="getCorrectLetter(selectedQuestion) === 'C'" *ngIf="selectedQuestion.hindiOptionCText">
                <b>(c)</b> <span [innerHTML]="fmt(selectedQuestion.hindiOptionCText)"></span>
              </div>
              <div class="detail-opt" [class.correct]="getCorrectLetter(selectedQuestion) === 'D'" *ngIf="selectedQuestion.hindiOptionDText">
                <b>(d)</b> <span [innerHTML]="fmt(selectedQuestion.hindiOptionDText)"></span>
              </div>
            </div>
          </div>
          <div class="detail-section" *ngIf="selectedQuestion.hindiExplanationText">
            <div class="detail-label">&#x0935;&#x094D;&#x092F;&#x093E;&#x0916;&#x094D;&#x092F;&#x093E; (Hindi)</div>
            <p class="detail-text hindi-text" [innerHTML]="fmt(selectedQuestion.hindiExplanationText)"></p>
          </div>
        </ng-container>

        <!-- Explanation -->
        <div class="detail-section">
          <div class="detail-label">Explanation</div>

          <p class="detail-text" *ngIf="!getBlocks(selectedQuestion).length && selectedQuestion.explanationText"
             [innerHTML]="fmt(selectedQuestion.explanationText)"></p>

          <ng-container *ngIf="getBlocks(selectedQuestion).length > 0">
            <ng-container *ngFor="let block of getBlocks(selectedQuestion)">
              <p *ngIf="block.type === 'text'" class="expl-text" [innerHTML]="fmt(block.content)"></p>
              <div *ngIf="block.type === 'table'" class="expl-table-wrap">
                <table class="expl-table">
                  <thead *ngIf="block.headers && block.headers.length">
                    <tr><th *ngFor="let h of block.headers">{{ h }}</th></tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of block.rows">
                      <td *ngFor="let cell of row">{{ cell }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="block.type === 'figure' && block.imageUrl" class="expl-figure">
                <img [src]="block.imageUrl" [alt]="block.content" class="expl-fig-img">
                <p *ngIf="block.content" class="expl-fig-caption">{{ block.content }}</p>
              </div>
            </ng-container>
          </ng-container>

        </div>
      </div>
    </ng-container>
  </aside>

</div>

<!-- Reset notification -->
<div class="reset-notification" *ngIf="showResetNotification">
  Panel sizes reset to default
</div>
